import type { SingleAnswerQuestion } from '@feh/shared-ui';

export const homebatteryQuestionnaireStructure: {
  [key: string]: SingleAnswerQuestion;
} = {
  hasSolarPanels: {
    type: 'single-answer-question',
    question: 'Heb je zonnepanelen?',
    apiKey: 'hasSolarPanels',
    trackingStepName: 'hasSolarPanels',
    percentage: 20,
    options: [
      {
        label: 'Ja',
        automationId: 'hasSolarPanels.yes',
        apiValue: true,
        target: {
          type: 'next-question',
          questionName: 'generatedPower',
        },
      },
      {
        label: 'Nee',
        apiValue: false,
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
    ],
  },
  generatedPower: {
    type: 'single-answer-question',
    question: 'Hoeveel wek je jaarlijks op met je zonnepanelen?',
    apiKey: 'generatedPower',
    trackingStepName: 'generatedPower',
    percentage: 50,
    options: [
      {
        label: '0 - 2.000 kWh',
        automationId: 'generatedPower.belowTwoThousand',
        apiValue: '0 - 2.000 kWh',
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
      {
        label: '2.001 - 4.000 kWh',
        apiValue: '2.001 - 4.000 kWh',
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
      {
        label: '4.001 - 6.000 kWh',
        apiValue: '4.001 - 6.000 kWh',
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
      {
        label: '6.001 - 8.000 kWh',
        apiValue: '6.001 - 8.000 kWh',
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
      {
        label: '8.001 - 10.000 kWh',
        apiValue: '8.001 - 10.000 kWh',
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
      {
        label: 'Meer dan 10.000 kWh',
        apiValue: 'Meer dan 10.000 kWh',
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
      {
        label: 'Weet ik niet',
        apiValue: null,
        target: {
          type: 'next-question',
          questionName: 'numberOfPanels',
        },
      },
    ],
  },
  numberOfPanels: {
    type: 'single-answer-question',
    question: 'Hoeveel zonnepanelen heb je?',
    apiKey: 'numberOfPanels',
    trackingStepName: 'numberOfPanels',
    percentage: 70,
    options: [
      {
        label: '1 - 5',
        automationId: 'numberOfPanels.oneToFive',
        apiValue: '1 - 5',
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
      {
        label: '6 - 12',
        apiValue: '6 - 12',
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
      {
        label: '13 - 18',
        apiValue: '13 - 18',
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
      {
        label: 'Meer dan 18',
        apiValue: 'Meer dan 18',
        target: {
          type: 'next-question',
          questionName: 'contractType',
        },
      },
    ],
  },
  contractType: {
    type: 'single-answer-question',
    question: 'Wat voor energiecontract heb je?',
    apiKey: 'contractType',
    trackingStepName: 'contractType',
    percentage: 90,
    options: [
      {
        label: 'Vast contract',
        automationId: 'contractType.fixedContract',
        apiValue: 'fixed',
        target: {
          type: 'link',
          funnelKey: 'orderPage',
        },
      },
      {
        label: 'Variabel contract',
        apiValue: 'variable',
        target: {
          type: 'link',
          funnelKey: 'orderPage',
        },
      },
      {
        label: 'Dynamisch contract',
        apiValue: 'Dynamisch contract',
        target: {
          type: 'link',
          funnelKey: 'orderPage',
        },
      },
      {
        label: 'Weet ik niet',
        apiValue: null,
        target: {
          type: 'link',
          funnelKey: 'orderPage',
        },
      },
    ],
  },
};
